<div class="changelog-container">
  <div class="changelog-header">
    <h1 class="changelog-title">Changelog</h1>
    <p class="changelog-subtitle">
      Hold dig opdateret med alle de seneste opdateringer og forbedringer.
    </p>

    <div class="changelog-controls">
      <app-changelog-filter (filterChange)="onCategoryFilterChange($event)">
      </app-changelog-filter>

      <app-changelog-search (searchChange)="onSearchChange($event)">
      </app-changelog-search>
    </div>
  </div>

  <div class="changelog-content">
    @if (isLoading) {
    <div class="loading-state">
      <p>Indlæser changelog-indlæg...</p>
    </div>
    } @if (error) {
    <div class="error-state">
      <p>{{ error }}</p>
      <button (click)="loadChangelogData()">Prøv igen</button>
    </div>
    } @if (!isLoading && !error) {
    <div class="changelog-timeline">
      @if (filteredEntries.length === 0) {
      <div class="no-results">
        <p>Ingen changelog-indlæg matcher dine nuværende filtre.</p>
      </div>
      } @for (entry of filteredEntries; track entry; let i = $index) {
      <!-- Group entries by month -->
      @if (i === 0 || getMonthYear(entry.date) !==
      getMonthYear(filteredEntries[i-1].date)) {
      <div class="month-divider">
        <span class="month-label">{{ entry.date | date : "MMMM yyyy" }}</span>
      </div>
      }
      <app-changelog-entry [entry]="entry"></app-changelog-entry>
      }
    </div>
    }
  </div>
</div>
